export default "__VITE_ASSET__BZMFPVQw__"